module.exports = __webpack_public_path__ + "static/img/UZ.32aec633.svg";